import { useTheme } from "@mui/material"
import { User } from "react-feather"
import { UserMenuLayout } from "./UserMenuLayout"
import type { UserMenuImplementationProps } from "./userMenu.model"

export const LaboratoryMenu = (props: UserMenuImplementationProps) => {
  const theme = useTheme()
  return (
    <UserMenuLayout
      {...props}
      items={[
        {
          Icon: User,
          iconColor: theme.palette.primary.main,
          label: "Mon laboratoire",
          to: "/mon-laboratoire",
        },
      ]}
    />
  )
}
